import { BottomNav } from './BottomNav'
import { SideNav } from './SideNav'

/**
 * Root layout wrapper that switches between BottomNav (mobile) and SideNav (tablet+)
 * using CSS classes only — no JavaScript breakpoint detection for layout switching.
 */
export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen">
      {/* Side nav — hidden on mobile, visible on md+ */}
      <div className="hidden md:block">
        <SideNav />
      </div>

      {/* Main content — offset by side nav width on md+ */}
      <main
        tabIndex={-1}
        className="flex-1 overflow-y-auto pb-[76px] md:pb-0 md:ml-16 lg:ml-[200px] outline-none"
      >
        {children}
      </main>

      {/* Bottom nav — visible on mobile, hidden on md+ */}
      <div className="md:hidden">
        <BottomNav />
      </div>
    </div>
  )
}
